<template>
  <v-alert type="error" text dense class="source-error" data-test="source-error">
    No se pudo cargar {{ label }}.
    <template v-slot:append>
      <v-btn small text color="error" data-test="source-error-retry" @click="$emit('retry')">
        Reintentar
      </v-btn>
    </template>
  </v-alert>
</template>

<script>
// Aviso de una fuente de datos de la 360 que no cargó (FR-022): la sección afectada lo muestra
// en lugar de su contenido y el contenedor vuelve a pedir solo esa fuente al recibir `retry`.
export default {
  name: 'SourceError360',
  props: {
    // Qué no se pudo cargar, en minúscula y con artículo: «las mascotas», «el tutor».
    label: { type: String, required: true }
  }
};
</script>

<style scoped>
.source-error {
  margin: 12px 16px;
}
</style>
